
import head from '~/mixins/MetaHead'
import { ucfirst } from '~/fc/Helpers/StringHelpers'
import { capitalizeUnitName } from '~/fc/Helpers/UnitHelpers'
import { UnitIndexMeta } from '~/fc/Constants/meta'
import { getUnitConverterPageInfo, getUnitTypePageInfo } from '~/fc/Dal/PageInfoRepo'
const unitTypes = ['length', 'weight', 'temperature', 'area', 'energy', 'power', 'frequency', 'electric', 'charge', 'voltage']

export default {
    name: 'UnitIndex',
    components: {
        UnitSingleIndex: () => import(/* webpackChunkName: "UnitSingleIndex" */ '~/layouts/ConverterTemplates/UnitSingleIndex'),
        UnitTypesIndex: () => import(/* webpackChunkName: "UnitTypesIndex" */ '~/layouts/ConverterTemplates/UnitTypesIndex')
    },
    mixins: [head],

    async asyncData({ route, store, params, redirect, error, app }) {
        const { path } = route
        if (path[path.length - 1] === '/') {
            return redirect(301, path.slice(0, path.length - 1))
        }
        store.commit('advancedSetting/clearOptions')
        const id = params.id
        let active = ''
        let type = ''
        let url = false

        if (id.search(/-converter$/g) !== -1) {
            type = id.replace('-converter', '')
            if (unitTypes.includes(type)) {
                url = 'unit/' + type
                active = 'UnitTypesIndex'
            }
            try {
                const data = await getUnitTypePageInfo(url, app)
                const info = { type, ...data, ...UnitIndexMeta(app), active }
                await store.dispatch('setInfo', info)
                return {
                    info,
                    active,
                    type,
                    title: info.title,
                    desc: info.desc || data.meta_description,
                    header_h1: info.header_h1,
                    subtext_h1: info.subtext_h1,
                    currentUrl: `/unit/${id}`
                }
            } catch (err) {
                error({ statusCode: 404, message: 'Page not found', error: err })
            }
        } else if (id.includes('-to-')) {
            type = 'query/view/convert/' + id
            try {
                const data = await getUnitConverterPageInfo(id, { app })
                if (data && data.status === 'error') {
                    error({ statusCode: 404, message: 'Page not found' })
                } else {
                    store.dispatch('setInfo', data)

                    return {
                        info: data,
                        active: data.action + 'Index',
                        type,
                        title: data.title,
                        desc: data.desc || data.meta_description,
                        currentUrl: `/unit/${id}`
                    }
                }
            } catch (err) {
                error({ statusCode: 404, message: 'Page not found', error: err })
            }
        } else {
            error({ statusCode: 404, message: 'Page not found' })
        }
    },
    data() {
        return {
            info: {},
            active: null,
            type: null,
            uid: 1
        }
    },
    mounted() {
        const fileType = this.info.type
        const id = this.$route.params.id
        let items = []

        if (unitTypes.includes(this.type)) {
            items = [{
                url: this.localePath('/unit-converter'),
                label: this.$t('converter_unit_converter')
            }, {
                url: this.localePath(`/unit/${id}`),
                label: ucfirst(this.type.replace(/-/g, ' ')) + ' ' + this.$t('converter')
            }]
        } else {
            items = [
                {
                    url: this.localePath('/unit-converter'),
                    label: this.$t('converter_unit_converter')
                },
                {
                    url: this.localePath(`/unit/${fileType}-converter`),
                    label: this.$t(ucfirst(fileType) ? ucfirst(fileType).toLowerCase() : '') + ' ' + this.$t('converter')
                },
                {
                    url: this.localePath(`/unit/${id}`),
                    label: `${capitalizeUnitName(this.info.source, 'common_name')} ${this.$t('to')} ${capitalizeUnitName(this.info.target, 'common_name')}`
                }
            ]
        }
        this.$store.commit('updateBreadcrumbs', items)
    },
    methods: {
        setData({ info, type }) {
            this.info = { ...info, ...UnitIndexMeta }
            this.type = type
            this.uid++
        }
    }
}
